import { z } from 'zod';
import { IsoDate } from './common.js';
import { ReservationListItem } from './reservations.js';
/**
 * Écran d'accueil « Aujourd'hui » (UX-001, D-008).
 * Toutes les listes utilisent `ReservationListItem` : la même carte est
 * réutilisée pour les arrivées, les départs et les séjours en cours.
 */
export const DashboardCounts = z.object({
    arrivals: z.number().int().nonnegative(),
    departures: z.number().int().nonnegative(),
    inHouse: z.number().int().nonnegative(),
    /** Réservations du jour dont le dossier documentaire est incomplet (R-001). */
    incompleteCompliance: z.number().int().nonnegative(),
    /** Ressources actives sans verrou sur la journée. */
    availableResources: z.number().int().nonnegative(),
    /** Options expirant dans les 48 heures (R-009). */
    optionsExpiringSoon: z.number().int().nonnegative(),
    /** Une session de caisse est-elle ouverte sur l'établissement observé (E-12) ? */
    cashSessionOpen: z.boolean(),
});
export const DashboardToday = z.object({
    date: IsoDate,
    arrivals: z.array(ReservationListItem),
    departures: z.array(ReservationListItem),
    inHouse: z.array(ReservationListItem),
    counts: DashboardCounts,
    /** Somme des soldes restant dus sur les arrivées et départs du jour. */
    expectedPaymentsTotal: z.number(),
    /**
     * Encaissé du jour : paiements non annulés de la journée (fuseau de
     * l'établissement), remboursements déduits.
     */
    todayCollected: z.number(),
    currencyCode: z.string().length(3),
});
export const DashboardTodayQuery = z.object({
    propertyId: z.string().uuid().optional(),
    /** Journée observée (fuseau de l'établissement) ; défaut : aujourd'hui. */
    date: IsoDate.optional(),
});
//# sourceMappingURL=dashboard.js.map